import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landingpage from "./pages/landingpage/landingpage";
import SobreNos from "./pages/sobreNos/sobreNos";
import OEscritorio from "./pages/oEscritorio/oEscritorio";
import NossaEquipe from "./pages/nossaEquipe/nossaEquipe";
import PoliticaPrivacidade from "./pages/politicaPrivacidade/politicaPrivacidade";
import NotFound from "./pages/notFound/notFound";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";

export default function Index() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Rotas Canônicas (Padrão Kebab-Case) */}
        <Route path="/" element={<Landingpage />} />
        <Route path="/sobre-nos" element={<SobreNos />} />
        <Route path="/o-escritorio" element={<OEscritorio />} />
        <Route path="/nossa-equipe" element={<NossaEquipe />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />

        {/* 404 - Página Não Encontrada */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
